module.exports = __webpack_public_path__ + "static/img/oak poppy seed.4857d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/oak poppy seed.jpg
// module id = vKZ8
// module chunks = 0